<template>
  <div class="dataStatistics">
    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div>居住现状统计</div>
          <div class="echarts" id="echartsTopLeft"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div>房屋用途统计</div>
          <div class="echarts" id="echartsTopRight"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="24">
        <el-card class="box-card">
          <div>区域统计</div>
          <div class="echarts" id="echartsBottom"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  watchEffect,
  toRefs,
  ref,
  onMounted
} from "vue";
import * as echarts from "echarts";
export default defineComponent({
  name: "dataStatistics",
  components: {},
  props: {},
  setup(props, context) {
    const state = reactive({
      formVisible: false
    });
    const refData = toRefs(state);
    let myChartTopLeft, myChartTopRight, myChartBottom;
    const echartsTopLeft = () => {
      myChartTopLeft = echarts.init(document.getElementById("echartsTopLeft"));
      const optionData = [
        { value: 270, name: "空置" },
        { value: 116, name: "自用" },
        { value: 61, name: "租用" },
        { value: 20, name: "借用" },
        { value: 16, name: "家庭租用" },
        { value: 4, name: "自用&租用" }
      ];
      const option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          left: "10%",
          top: "center",
          orient: "vertical",
          itemGap: 20,
          width: 300,
          formatter: function(params) {
            switch (params) {
              case "空置":
                return params + "    " + optionData[0].value;
                break;
              case "自用":
                return params + "    " + optionData[1].value;
                break;
              case "租用":
                return params + "    " + optionData[2].value;
                break;
              case "借用":
                return params + " " + optionData[3].value;
                break;
              case "家庭租用":
                return params + " " + optionData[4].value;
                break;
              case "自用&租用":
                return params + " " + optionData[5].value;
                break;
              default:
                return "";
            }
          }
        },
        grid: {
          top: 20,
          left: 20
        },
        series: [
          {
            name: "居住现状",
            type: "pie",
            radius: ["50%", "80%"],
            center: ["60%", "53%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              fontWeight: "bold",
              formatter: function(params) {
                let str = 0;
                optionData.forEach(item => {
                  str += Number(item.value);
                });
                return params.seriesName + "\n" + str;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: optionData
          }
        ]
      };
      myChartTopLeft.setOption(option);
    };
    const echartsTopRight = () => {
      myChartTopRight = echarts.init(
        document.getElementById("echartsTopRight")
      );
      let option = {
        color: ["#8666ff"],
        grid: {
          top: "10%",
          left: "5%",
          right: "5%",
          bottom: "10%"
        },
        xAxis: {
          type: "category",
          data: ["未知", "住宅", "商业"],
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [261, 225, 1],
            type: "bar",
            barMaxWidth: 170,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    fontSize: 16,
                    color: "#8666ff"
                  }
                }
              }
            }
          }
        ]
      };
      myChartTopRight.setOption(option);
    };
    const echartsBottom = () => {
      myChartBottom = echarts.init(document.getElementById("echartsBottom"));
      let option = {
        color: ["#6edfff"],
        grid: {
          top: "10%",
          left: "5%",
          right: "5%"
        },
        xAxis: {
          type: "category",
          data: ["汉丰街道", "云枫街道"],
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [478, 9],
            type: "bar",
            barMaxWidth: 170,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    fontSize: 16,
                    color: "#6edfff"
                  }
                }
              }
            }
          }
        ]
      };
      myChartBottom.setOption(option);
    };
    onMounted(() => {
      echartsTopLeft();
      echartsTopRight();
      echartsBottom();
      window.addEventListener("resize", () => {
        myChartTopLeft.resize();
        myChartTopRight.resize();
        myChartBottom.resize();
      });
    });
    return {
      ...refData
    };
  }
});
</script>
<style lang="scss" scoped>
.dataStatistics {
  .el-row {
    height: 40%;
    .el-col {
      height: 100%;
      .el-card {
        height: 100%;
        .echarts {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .el-row + .el-row {
    height: 58%;
    margin-top: 1%;
  }
}
</style>
